// extracted by mini-css-extract-plugin
export default {"current":"word_current__eBsyd","correct":"word_correct__nVMYZ","wrong":"word_wrong__eFE8H","caret":"word_caret__ZvSUA","blink":"word_blink__TUSWE","active":"word_active__T9hkQ"};